import { useCurrentRefinements } from "react-instantsearch";
import Icon from "@repo/ui/components/ui/icon/icon";
import { useLocale, useTranslations } from "next-intl";
import { useAlgoliaSortBy } from "@/hooks/useAlgoliaSortBy";
import { useGender } from "@components/search/hooks/useGender";
import { useNormalizedColors } from "@components/search/hooks/useNormalizedColors";

export default function AlgoliaCurrentRefinements() {
  const t = useTranslations("Products-list.filters");
  const locale = useLocale().substring(0, 2) as "it" | "en";
  const colorsMap = useNormalizedColors();
  const { items, refine } = useCurrentRefinements();
  const { itemsFilterRule, toggleGroup } = useGender();
  const { refine: refineSortBy, currentRefinement: currentOrder } =
    useAlgoliaSortBy();

  const refinementLabels = (attribute: string, label: string = "") => {
    switch (attribute) {
      case "categoryIt.lvl0":
      case "categoryIt.lvl0":
        return `${t("category")}: ${label.split(">").pop()}`;
      case "brand":
        return label;
      case "size":
        return `${t("size")}: ${label}`;
      case "colorsNormalized":
        return `${t("color")}: ${colorsMap?.[label]?.[locale]}`;
      case "gender":
        return `${t("gender")}: ${t(label.toLowerCase())}`;
      case "minVariantTargetPrice":
        return `${t("price")}: ${label}`;
      case "products_price_asc":
        return `${t("order")}: ${t("order-asc")}`;
      case "products_price_desc":
        return `${t("order")}: ${t("order-desc")}`;
    }
  };

  const handleRefine = (refinement: any) => {
    const { attribute, value } = refinement;
    if (attribute === "gender") {
      toggleGroup(value);
    } else {
      refine(refinement);
    }
  };

  return (
    <div className="flex flex-wrap gap-2 mt-6 mb-10 max-md:text-[14px] font-bold">
      {currentOrder !== "products" && (
        <button
          key={`order-${currentOrder}`}
          onClick={() => refineSortBy("products")}
          className="rounded-[20px] bg-secondary-gray1 dark:bg-secondary-gray4 py-2 px-4 flex items-center gap-2"
          type="button"
        >
          <span>{refinementLabels(currentOrder)}</span>
          <Icon icon="Close" className="h-[20px] w-[20px]" />
        </button>
      )}

      {items.flatMap((item) =>
        item.refinements.filter(itemsFilterRule).map((refinement) => {
          const customLabel = refinementLabels(
            item.attribute,
            refinement.label,
          );

          return (
            <button
              key={`${item.attribute}-${refinement.label}-${refinement.value}`}
              onClick={() => handleRefine(refinement)}
              className="rounded-[20px] bg-secondary-gray1 dark:bg-secondary-gray4 py-2 px-4 flex items-center gap-2"
              type="button"
            >
              <span>{customLabel}</span>
              <Icon icon="Close" className="h-[20px] w-[20px]" />
            </button>
          );
        }),
      )}
    </div>
  );
}
